<div class="wrapper">
	<div class="header-block">
		<ion-img src="../../../assets/topgolf/header_logo.svg"></ion-img>
		<ion-chip (click)="dismiss()">
			<ion-icon src="../../../assets/icon/white_cross.svg"></ion-icon>
		</ion-chip>
	</div>
	<div class="footer-section">
		<p>{{ 'no_orders.title' | translate }}</p>
		@if (!isInMenu) {
			<ion-button (click)="closeWithTrue()"> {{ 'no_orders.btn' | translate }}</ion-button>
		}
		@if (isInMenu) {
			<ion-button (click)="dismiss()"> {{ 'no_orders.continue' | translate }}</ion-button>
		}
	</div>
</div>
